export default "__VITE_ASSET__CTOz5IHj__"